import { Component } from '@angular/core';

@Component({
    selector: 'app-svg-loading',
    templateUrl: './svg.loading.component.html',
    styleUrls: ['./svg.loading.component.scss'],
    standalone: false
})
export class SvgLoadingComponent {
}
